import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import OrbitalLoader from "../common/OrbitalLoader";
import { brandsService } from "../../services/brands";
import { setCurrentBrand } from "../../redux/brand/brandSlice";

const LegacyBrandRedirect = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hash) {
      navigate("/", { replace: true });
      return;
    }

    brandsService.getBrand(
      hash,
      (response) => {
        if (response?.data) {
          dispatch(setCurrentBrand(response.data));
        }
        navigate("/brand/overview/", { replace: true });
      },
      () => navigate("/", { replace: true }),
    );
  }, [dispatch, hash, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-theme-secondary">
      <OrbitalLoader size={128} />
    </div>
  );
};

export default LegacyBrandRedirect;
